import React from 'react'
import { useParams } from 'react-router-dom'
import { apiGenerator } from '../../../../util/functions'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import { Card, Row } from 'antd'
import Heading from '../../../../component/common/Heading'
import CRUDComponent from '../../../../component/common/CRUD-Component'

const Transaction = () => {
    const { id } = useParams()

    // console.log(id);

    const userTransactionApi = apiGenerator(CONSTANTS.API.Transaction.getAll, {}, `?userId=${id}`)
    return (
        <>
            <div>
                <Card>
                    <Heading>Transactions</Heading>

                    <Row>
                        <CRUDComponent
                            GET={{
                                API: userTransactionApi,
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `T${data?.id.toString().padStart(7, "0")}`,
                                            name: 'Subscription',


                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.USER_TRANSACTION,
                            }}
                            isSearch={true}

                        />
                    </Row>
                </Card>
            </div>

        </>
    )
}

export default Transaction